export default "__VITE_ASSET__lOxD$VWc__"